import { createFileRoute, Link, Outlet, useRouter } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import PublicNav from "@/public/components/PublicNav";

export const Route = createFileRoute("/_public")({
	beforeLoad: async ({ context, location }) => {
		
	},
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<div>
				<PublicNav />
			</div>
			<Outlet />
		</>
	);
}